import React from 'react'

import Spinner from '../ui/spinner'
import { ReactComponent as SendIcon } from '../../static/images/send.svg'
import { ReactComponent as MoneyIcon } from '../../static/images/money.svg'

type Props = {
  sendLabel: string
  viewPdfLabel: string
  isSendingToEmail: boolean
  isPreparingPdf: boolean
  sendDisabled: boolean
  viewPdfDisabled: boolean
  onSend: (e: React.MouseEvent) => void
  onViewPdf: (e: React.MouseEvent) => void
}

const GuestInvoiceActions: React.FC<Props> = ({
  sendLabel,
  viewPdfLabel,
  isSendingToEmail,
  isPreparingPdf,
  sendDisabled,
  viewPdfDisabled,
  onSend,
  onViewPdf,
}) => (
  <div className='guest-invoice-actions'>
    <button
      type='button'
      className='guest-invoice-actions__tile guest-invoice-actions__tile--primary'
      onClick={onSend}
      disabled={sendDisabled}
      aria-busy={isSendingToEmail}
    >
      {isSendingToEmail ? <Spinner /> : <SendIcon width={28} />}
      <span className='guest-invoice-actions__title'>
        {isSendingToEmail ? 'Saving' : sendLabel}
      </span>
      <span className='guest-invoice-actions__hint'>Email this invoice to your client</span>
    </button>
    <button
      type='button'
      className='guest-invoice-actions__tile'
      onClick={onViewPdf}
      disabled={viewPdfDisabled}
      aria-busy={isPreparingPdf}
    >
      {isPreparingPdf ? <Spinner /> : <MoneyIcon width={28} />}
      <span className='guest-invoice-actions__title'>
        {isPreparingPdf ? 'Preparing Invoice…' : viewPdfLabel}
      </span>
      <span className='guest-invoice-actions__hint'>Preview or download a PDF copy</span>
    </button>
  </div>
)

export default GuestInvoiceActions
